// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../../components/Button';
const S = {
  Avatar: styled.img`
    margin-left: 0px;
    border-radius: 50%;
    width: 60px;
    height: 60px;
  `,
  MessageWrapper: styled.div`
    width: 100%;
    display: inline-flex;
    margin-bottom: 31px;
  `,
  Message: styled.div`
    width: 445px;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    padding: 14px 20px 21px 20px;
    background: rgba(255, 209, 99, 0.3);
    border-radius: 4px;
  `,
  Name: styled.div`
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    color: #434343;
    margin-bottom: 7px;
  `,
  Button: styled(Button)`
    height: 44px;
    width: 112px;
    margin-top: 14px;
    background: #EF8200;
    border-radius: 4px;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
  `,
  MessageText: styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
  `,
  MessageImages: styled.div`
    display: inline-block;
    flex-direction: row;
    margin-top: 14px;
  `,
  MessageButton: styled.div`
    display: inline-block;
    flex-direction: row;
    margin-top: 14px;
  `,
  Time: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #848484;
    margin-top: 16px;
  `,
  Image: styled.img`
    height: 100%;
    cursor: zoom-in;
  `,
  ImageItemContainer: styled.div`
    margin-left: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: 137px;
    width: 137px;
  `,
};

export { S as default };

